import {
  AllMspOrgsSolutionWithUsage,
  AllMspOrgsWithLicencesResponse,
  Msp,
} from "../types";
import { ALL_SERVICES } from "@/utils/services.ts";
import add from "@/utils/reduce-add.ts";
import { OrganisationConnection } from "@/types/organisatio.ts";

export const transformOrganisationsToMsp = (
  organisations: AllMspOrgsWithLicencesResponse[],
  connections: OrganisationConnection[] = [],
): Msp[] => {
  const connectionsDictionary = connections.reduce(
    (acc: Record<string, boolean>, cur) => {
      acc[cur.organisation_uuid] = cur.connected;
      return acc;
    },
    {},
  );

  return organisations.map((organisation: AllMspOrgsWithLicencesResponse) => {
    const {
      licence,
      uuid,
      name,
      description,
      created_at,
      organisation_type,
      parent_uuid,
      parent_name,
      auth0_migration_version,
    } = organisation;

    const totalActiveUsers = getMaxActiveUsers(licence);
    const totalSeatsPurchased = getTotalSeatsPurchased(licence);
    const solutions = mapSolutionsToServices(licence);
    const hasConnection = connectionsDictionary[organisation.uuid] ?? false;

    return {
      uuid,
      name,
      description: description ?? "",
      organisation_type,
      parent_uuid,
      parent_name,
      seats_used: totalActiveUsers,
      seats_purchased: totalSeatsPurchased,
      created_at,
      solutions,
      hasConnection,
      auth0_migration_version,
    };
  });
};

const getMaxActiveUsers = (licence: {
  solutions: AllMspOrgsSolutionWithUsage[];
}): number => {
  if (!licence?.solutions?.length) return 0;

  return Math.max(
    ...licence.solutions.map((solution: AllMspOrgsSolutionWithUsage) =>
      Number.isInteger(solution.seats_used) ? solution.seats_used : 0,
    ),
  );
};

const getTotalSeatsPurchased = (licence: {
  solutions: AllMspOrgsSolutionWithUsage[];
}): number => {
  if (!licence?.solutions?.length) return 0;

  return licence.solutions
    .map((solution: AllMspOrgsSolutionWithUsage) =>
      Number.isInteger(solution.seats_purchased) ? solution.seats_purchased : 0,
    )
    .reduce(add, 0);
};

const mapSolutionsToServices = (licence?: {
  solutions?: AllMspOrgsSolutionWithUsage[];
}) => {
  return ALL_SERVICES.map((service) => ({
    ...service,
    isServiceEnabled: Array.isArray(licence?.solutions)
      ? licence.solutions.some(
          (availableService: AllMspOrgsSolutionWithUsage) =>
            availableService.solution_uuid === service.uuid,
        )
      : false,
  }));
};
